import MobileDetect from 'mobile-detect'

/**
 * @description look if it's Safari browser
 * @returns {boolean}
 */
export const isSafari = () => {
    let isBrowserSafari = false
    const ua = navigator.userAgent.toLowerCase()
    if (ua.indexOf('safari') !== -1) {
        let detectableTermsInUa = ['crios', 'chrome']
        detectableTermsInUa = detectableTermsInUa.filter((term) => ua.indexOf(term) > -1)
        if (detectableTermsInUa.length > 0) isBrowserSafari = false
        else isBrowserSafari = true
    }
    return isBrowserSafari
}

/**
 * @description look if it's mobile device
 * @returns {boolean}
 */
export const isMobileOrTabletBrowser = () => {
    const md = new MobileDetect(navigator.userAgent)
    const isNewIpad =
        window.navigator.userAgent.match(/Mac/) &&
        window.navigator.maxTouchPoints &&
        window.navigator.maxTouchPoints > 2
    const isIpad = navigator.platform.match(/iPad/i)
    const res = !!md.mobile() || !!md.phone() || !!md.tablet() || !!isNewIpad || !!isIpad
    return res
}

/**
 * @description generates random id
 * @param {Number} length minimum id length
 * @returns {String}
 */
export const generateRandomGuiID = (length = 12) => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

    let result = ''

    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length))
    }

    return result
}

export const hexToRgba = (hex: string, opacity: number) => {
    let c
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split('')
        if (c.length === 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]]
        }
        c = `0x${c.join('')}`
        // @ts-expect-error TS(2362) FIXME: The left-hand side of an arithmetic operation must... Remove this comment to see the full error message
        // eslint-disable-next-line no-bitwise
        return `rgba(${[(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',')},${opacity})`
    }
    console.warn('Bad hex')
    return hex
}
